import { IActionFn, IPageData } from '@/store/types';
import { IModuleState, IAddResData, IAddResMsg } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询关键字列表
export const queryKeywords: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setKeywords', { ...state.list, loading: true });
    // const res: IPageData = await $http.post('/keyword/list', payload);
    const res: IPageData = await $http.post('/v1/baseinfo/keyword/list', payload);
    const data = res.list.map((item, index) => ({ id: index, ...item }));
    commit('setKeywords', { data, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setKeywords', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询某个关键字关联的物品列表
export const queryKeywordModel: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setKeywordSubList', { ...state.subList, loading: true });
    // const res: IPageData = await $http.post('/model/type/item/keywords/page', payload);
    const res: IPageData = await $http.post('/v1/baseinfo/keyword/itempagelist', payload);
    commit('setKeywordSubList', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setKeywordSubList', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询某个关键字关联的材料列表
export const queryKeywordMaterial: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setKeywordSubList', { ...state.subList, loading: true });
    // const res: IPageData = await $http.post('/material/type/item/keywords/page', payload);
    const res: IPageData = await $http.post('/v1/baseinfo/keyword/materialpagelist', payload);
    commit('setKeywordSubList', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setKeywordSubList', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 新增关键字
export const addKeyword: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  // const res: IAddResData = await $http.post('/keyword/add', payload);
  const res: IAddResData = await $http.post('/v1/baseinfo/keyword/add', payload);
  if (res.failCode === 1901) {
    store.commit('common/setToast', { visible: true, text: '未找到相关物品，请检查物品列表' });
  } else if (res.failCode === 1902) {
    store.commit('common/setToast', { visible: true, text: '未找到相关材料，请检查材料列表' });
  } else {
    const list: IAddResMsg[] = JSON.parse(res.message || '[]');
    const added = res.newKeyWord;
    const nmodel = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.nmodel || '[]')], []);
    const nmaterial = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.nmaterial || '[]')], []);
    const uaumodel = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.uaumodel || '[]')], []);
    const uaumaterial = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.uaumaterial || '[]')], []);
    const addMsg = added.length
      ? `<b>新增关键字（共${added.length}个）：</b><br>${added.join('、')}<br>`
      : '';
    const existModelMsg = nmodel.length
      ? `<b>已绑定的物品（共${nmodel.length}个）：</b><br>${nmodel.join('<br>')}`
      : '';
    const existMMaterialMsg = nmaterial.length
      ? `<b>已绑定的材料（共${nmaterial.length}个）：</b><br>${nmaterial.join('<br>')}`
      : '';
    const notExistModelMsg = uaumodel.length
      ? `<b>不存在的物品（共${uaumodel.length}个）：</b><br>${uaumodel.join('<br>')}`
      : '';
    const notExistMaterialMsg = uaumaterial.length
      ? `<b>不存在的材料（共${uaumaterial.length}个）：</b><br>${uaumaterial.join('<br>')}`
      : '';
    const extraMsg = addMsg + existModelMsg + existMMaterialMsg + notExistModelMsg + notExistMaterialMsg;
    const timeout = extraMsg ? -1 : 5000; // 有额外的信息，则永不消失，否则5秒后消失
    store.commit('common/setToast', { visible: true, text: `绑定成功！<br>${extraMsg}`, timeout });
  }
};

// 编辑
export const editKeyword: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  // const res: IAddResData = await $http.post('/keyword/modify', payload);
  const res: IAddResData = await $http.post('/v1/baseinfo/keyword/modify', payload);
  if (res.failCode === 1901) {
    store.commit('common/setToast', { visible: true, text: '未找到相关物品，请检查物品列表' });
  } else if (res.failCode === 1902) {
    store.commit('common/setToast', { visible: true, text: '未找到相关材料，请检查材料列表' });
  } else {
    const list: IAddResMsg[] = JSON.parse(res.message || '[]');
    const added = res.newKeyWord;
    const nmodel = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.nmodel || '[]')], []);
    const nmaterial = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.nmaterial || '[]')], []);
    const uaumodel = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.uaumodel || '[]')], []);
    const uaumaterial = list.reduce<string[]>((acc, cur) => [...acc, ...JSON.parse(cur.uaumaterial || '[]')], []);
    const addMsg = added.length
      ? `<b>新增关键字（共${added.length}个）：</b><br>${added.join('、')}<br>`
      : '';
    const existModelMsg = nmodel.length
      ? `<b>已绑定的物品（共${nmodel.length}个）：</b><br>${nmodel.join('<br>')}`
      : '';
    const existMMaterialMsg = nmaterial.length
      ? `<b>已绑定的材料（共${nmaterial.length}个）：</b><br>${nmaterial.join('<br>')}`
      : '';
    const notExistModelMsg = uaumodel.length
      ? `<b>不存在的物品（共${uaumodel.length}个）：</b><br>${uaumodel.join('<br>')}`
      : '';
    const notExistMaterialMsg = uaumaterial.length
      ? `<b>不存在的材料（共${uaumaterial.length}个）：</b><br>${uaumaterial.join('<br>')}`
      : '';
    const extraMsg = addMsg + existModelMsg + existMMaterialMsg + notExistModelMsg + notExistMaterialMsg;
    const timeout = extraMsg ? -1 : 5000; // 有额外的信息，则永不消失，否则5秒后消失
    store.commit('common/setToast', { visible: true, text: `绑定成功！<br>${extraMsg}`, timeout });
  }
};

// 解绑
export const delKeyword: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  // const res: any = await $http.post('/keyword/delete', payload);
  const res: any = await $http.post('/v1/baseinfo/keyword/delete', payload);
  if (res.failCode === 1901) {
    store.commit('common/setToast', { visible: true, text: '未找到相关物品，请检查物品列表' });
  } else if (res.failCode === 1902) {
    store.commit('common/setToast', { visible: true, text: '未找到相关材料，请检查材料列表' });
  } else {
    store.commit('common/setToast', { visible: true, text: '解绑成功' });
  }
};

// 删除
export const removeKeyword: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/keyword/deletekeywords', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
